// extracted by mini-css-extract-plugin
module.exports = {"colorPattern":"QR4QPv","checkbox":"UmzzZQ","withBorder":"NVtG26"};